import Button from "./Button";

export function ConfirmButton({ onClick, disabled }) {
  return (
    <Button
      type="primary"
      label="Confirm"
      size="small"
      disabled={disabled || false}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
